import React from 'react';
import Crossflowfilter from "../../../assets/images/Cross-flowfilter.png";
import PlateFilter from "../../../assets/images/PlateFilter.png";
import PressFilter from "../../../assets/images/Pressfilter.png";
import Kieselguhrfilter from "../../../assets/images/kieselguhrfilter.png";
import VacuumFilter from "../../../assets/images/VacuumFilter.png";
import Microfiltration from "../../../assets/images/Microfiltration.png";
import { useTranslation } from 'react-i18next';

function Filter() {
  const { t } = useTranslation();

  const products = [
    {
      name: t('Cross-flow filter'),
      description: t('Crossflow filtration is a technique widely used in the wine industry for the clarification and filtration of wine. It is a more advanced and efficient method compared to traditional filtration methods such as pad or diatomaceous earth filtration. In crossflow filtration, wine is passed across a filtration membrane under pressure. Unlike other filtration methods where the liquid flows perpendicular to the filter media, in crossflow filtration, the liquid flows tangentially across the membrane surface which prevents the clogging of the filter and provides a better overall result.'),
      image: Crossflowfilter,
    },
    {
      name: t('Plate Filter'),
      description: t('Plate filters consist of plastic plates which hang in a steel frame. The filtration media (stuff that actually does the filtering) are square pads (also called sheets) of cellulose fibers that are placed between the plates in the filter.'),
      image: PlateFilter,
    },
    {
      name: t('Press Filter'),
      description: t('A special kind of a filter which is used to receive an efficient, high quality product in a short amount of time.'),
      image: PressFilter,
    },
    {
      name: t('Kieselgur Filter'),
      description: t('This type of filter relies on a unique system that keeps the filter cake intact even in the case of accidental interruptions in the filtering process. The emptying and cleaning operations are quick and easy, and servicing procedures also take up very little time because the filter’s structure has been designed to facilitate these activities to the utmost.'),
      image: Kieselguhrfilter,
    },
    {
      name: t('Vacuum Filter'),
      description: t('The vacuum filters have been designed and manufactured for the effective filtering of wine, lees, and byproducts of winemaking in general. They enable an efficient filtering in a continuous cycle with perfect results without any oxidation.'),
      image: VacuumFilter,
    },
    {
      name: t('Microfiltration'),
      description: t('Cross-flow microfiltration could be an alternative for traditional solid–liquid separation technologies such as centrifugation, filtration on sheets, diatomaceous earth filtration, and the use of exogenous additives during wine making.'),
      image: Microfiltration,
    },
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          <img src={product.image} alt={product.name} />
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Filter;
